import React from 'react'
import '../styles/seventhcontainer.scss'

const Seventhcontainer = () => {
  return (
    <div className="seventh__container">
      <h1>Sucess Stories</h1>
      <div className="group__images">
        <img className="john" src="/images/john.png" alt="" />
        <img className="singh" src="/images/yogendra-singh.png" alt="" />
        <img className="james" src="/images/james-timothy.png" alt="" />
      </div>
      <p>We have built hospitals, arranged doctor appointments have the diagnose and treat yourem ipsu r aol ad meniam, quis nostrud exercitation. We doctor appointments have the diagnose and treat yourem ipsu r exercitatranged docts have the diagnose and treat ipsu r aol</p>
    </div>
  )
}

export default Seventhcontainer
